import React, { useState } from "react"
import Select from "react-select"
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  Button,
} from "reactstrap"
import * as Yup from "yup"
import { Formik, Field, ErrorMessage } from "formik"

const customSelectStyles = {
  menu: provided => ({
    ...provided,
    backgroundColor: "white",
  }),
  control: provided => ({
    ...provided,
    backgroundColor: "white",
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused ? "#f0f0f0" : "white",
    color: "black",
  }),
}

function TransferToAnotherTeam({
  conversationActions,
  selectAnotherTeamModal,
  toggleSelectAnotherTeamModal,
  anotherTeams,
}) {
  const [selectedTeamUsers, setSelectedTeamUsers] = useState([])

  const teamOptions = anotherTeams?.teams?.map(team => ({
    value: team?._id,
    label: team?.name,
    users: team?.users,
  }))

  return (
    <Modal
      isOpen={selectAnotherTeamModal}
      toggle={toggleSelectAnotherTeamModal}
      centered
    >
      <Formik
        initialValues={{ selectedTeam: "", teamUser: "" }}
        validationSchema={Yup.object().shape({
          selectedTeam: Yup.string().required("You need to select a team"),
          teamUser: Yup.string().nullable(),
        })}
        onSubmit={values => {
          conversationActions(
            "transferToTeam",
            values.teamUser,
            values.selectedTeam
          )
          toggleSelectAnotherTeamModal()
        }}
      >
        {({ values, setFieldValue, handleSubmit }) => (
          <Form onSubmit={handleSubmit}>
            <ModalHeader toggle={toggleSelectAnotherTeamModal}>
              Select Another Team
            </ModalHeader>
            <ModalBody
              style={{
                maxHeight: "40vh",
                overflow: "auto",
                minHeight: "40vh",
              }}
            >
              <Select
                options={teamOptions}
                value={teamOptions.find(
                  option => option.value === values.selectedTeam
                )}
                onChange={selectedOption => {
                  setFieldValue("selectedTeam", selectedOption.value)
                  setFieldValue("teamUser", "")
                  setSelectedTeamUsers(selectedOption.users || [])
                }}
                styles={customSelectStyles}
                placeholder="Select another team"
              />
              <ErrorMessage
                name="selectedTeam"
                component="div"
                className="text-danger"
              />

              {/* Select User (Optional) */}
              {selectedTeamUsers.length > 0 && (
                <>
                  <Select
                    options={selectedTeamUsers.map(user => ({
                      value: user._id,
                      label: `${user.firstName} ${user.lastName}`,
                    }))}
                    value={
                      selectedTeamUsers.find(
                        user => user._id === values.teamUser
                      )
                        ? {
                            value: values.teamUser,
                            label:
                              selectedTeamUsers.find(
                                user => user._id === values.teamUser
                              )?.firstName +
                              " " +
                              selectedTeamUsers.find(
                                user => user._id === values.teamUser
                              )?.lastName,
                          }
                        : null
                    }
                    onChange={selectedOption => {
                      setFieldValue(
                        "teamUser",
                        selectedOption ? selectedOption.value : ""
                      )
                    }}
                    styles={customSelectStyles}
                    placeholder="Select a user (optional)"
                    className="mt-2"
                    isClearable
                  />
                </>
              )}
            </ModalBody>
            <ModalFooter style={{ borderTop: "0", paddingTop: "0" }}>
              <Button
                color="secondary"
                outline
                onClick={toggleSelectAnotherTeamModal}
                style={{ padding: "0.1875rem 0.875rem" }}
              >
                Cancel
              </Button>
              <Button
                color="secondary"
                type="submit"
                style={{ padding: "0.1875rem 0.875rem" }}
              >
                Submit
              </Button>{" "}
            </ModalFooter>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default TransferToAnotherTeam
